import React, { useEffect } from "react";
// import housingRule from "../../../Assets/propertyPage/housingRule.png";
import HowToBook from "../../../Assets/UserSide/HowToBook.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

function LinkTab({ title, navigateTo }) {
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
  }, []);
  return (
    <div
      className="sm:px-16 px-6 my-4"
      data-aos="zoom-in"
      onClick={() => navigate(`/${navigateTo}`)}
    >
      <div
        className="flex justify-between bg-cover bg-center items-center rounded-md sm:px-20 p-4 cursor-pointer hover:scale-105 duration-300 transition-all ease-in-out"
        style={{ backgroundImage: `url(${HowToBook})` }}
      >
        <h1 className="text-white text-lg">{title}</h1>
      </div>
    </div>
  );
}

export default LinkTab;
